import * as types from 'legacy/src/constants/types';
import { combineReducers } from 'redux';
import createReducer from 'legacy/src/shared/util/createReducer';
import { fetchAssignments } from './actions';

const initialState = {
  assignments: [],
  readinessCheck: null,
  loadingAssignments: false,
};

const reducer = createReducer(initialState, {
  [fetchAssignments.request]: (state) => ({
    ...state,
    loadingAssignments: true,
  }),
  [fetchAssignments.success]: (state, { payload }) => ({
    ...state,
    assignments: payload.assignments,
    readinessCheck: payload.readiness_check,
    loadingAssignments: false,
  }),
  [fetchAssignments.failure]: (state) => ({
    ...state,
    assignments: [],
    loadingAssignments: false,
  }),
});

const assignmentScroll = (
  state = {
    assignments: {},
  },
  action,
) => {
  switch (action.type) {
    case types.Assignment:
      return action.payload || {};
    default:
      return state;
  }
};

export default combineReducers({
  reducer,
  assignmentScroll,
});
